import { credibilityBarColor, credibilityLabel } from "@/utils/topicStyles";

type Props = {
  score: number;
  showLabel?: boolean;
  compact?: boolean;
};

export default function CredibilityMeter({ score, showLabel = true, compact = false }: Props) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between gap-3">
        <span className="font-label text-xs text-foreground-600">可信度</span>
        <span className="font-label text-xs font-semibold text-foreground-900">
          {score}
          {!compact && <span className="text-foreground-500"> / 100</span>}
        </span>
      </div>
      <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
        <div
          className={`h-full rounded-full ${credibilityBarColor(score)}`}
          style={{ width: `${score}%` }}
        />
      </div>
      {showLabel && (
        <p className="mt-1.5 font-label text-[11px] text-foreground-500">{credibilityLabel(score)}</p>
      )}
    </div>
  );
}